import React, {useState} from "react";
import {useFormik} from "formik";
import {connect} from "react-redux";
import * as Yup from "yup";
import {Link, useHistory} from "react-router-dom";
import * as auth from "../_redux/authRedux";
import {register} from "../_redux/authCrud";
import {useTranslation} from "react-i18next";

const initialValues = {
	name: "",
	phone: "",
	username: "",
	password: "",
	changepassword: "",
	acceptTerms: false,
};

function Registration(props) {
	const history = useHistory()
	const {t} = useTranslation('common');
	const [loading, setLoading] = useState(false);
	const RegistrationSchema = Yup.object().shape({
		name: Yup.string()
			.min(3, t('AtLeastCharacters'))
			.max(50, t('MaximumCharacters'))
			.required(
				t('AUTH.VALIDATION.REQUIRED_FIELD')
			),
		phone: Yup.string()
			.matches(/^09[0-9]{9}$/, t("AUTH.VALIDATION.INVALID_PHONE"))
			.required(
				t('AUTH.VALIDATION.REQUIRED_FIELD')
			),
		email: Yup.string()
			.optional()
			.email("Wrong email format"),
		username: Yup.string()
			.min(3, t('AtLeastCharacters'))
			.max(50, t('MaximumCharacters'))
			.required(
				t('AUTH.VALIDATION.REQUIRED_FIELD')
			),
		password: Yup.string()
			.min(3, t('AtLeastCharacters'))
			.max(50, t('MaximumCharacters'))
			.required(
				t('AUTH.VALIDATION.REQUIRED_FIELD')
			),
		changepassword: Yup.string()
			.required(
				t('AUTH.VALIDATION.REQUIRED_FIELD')
			)
			.when("password", {
				is: (val) => (val && val.length > 0 ? true : false),
				then: Yup.string().oneOf(
					[Yup.ref("password")],
					t('SamePassword')
				),
			}),
		acceptTerms: Yup.bool().required(
			t('AcceptRole')
		),
	});

	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};

	const getInputClasses = (fieldname) => {
		if (formik.touched[fieldname] && formik.errors[fieldname]) {
			return "is-invalid";
		}

		if (formik.touched[fieldname] && !formik.errors[fieldname]) {
			return "is-valid";
		}

		return "";
	};

	const formik = useFormik({
		initialValues,
		validationSchema: RegistrationSchema,
		onSubmit: (values, {setStatus, setSubmitting}) => {
			setSubmitting(true);
			enableLoading();
			register(values.phone, values.name, values.username, values.password,t('lang'))
				.then(({data}) => {
					const {success, error, needVerify} = data || {}
					if (success){
						if (needVerify) {
							setTimeout(() => {
								history.push(`/auth/verifyPhone/${(data?.phone)}`)
							}, 100)
							return
						}else{
							props.register(data.token);
						}
					}else{
						setStatus(error)
					}
					disableLoading();
					setSubmitting(false);
				})
				.catch(() => {
					setSubmitting(false);
					setStatus(
						"AUTH.VALIDATION.INVALID_LOGIN"
					);
					disableLoading();
				});
		},
	});

	return (
		<div className="login-form login-signin" style={{display: "block"}}>
			<div className="text-center mb-10 mb-lg-20">
				<h3 className="font-size-h1">
					{t('AUTH.REGISTER.TITLE')}
				</h3>
				<p className="text-muted font-weight-bold">
					{t('FillForm')}
				</p>
			</div>

			<form
				id="kt_login_signin_form"
				className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
				onSubmit={formik.handleSubmit}
			>
				{/* begin: Alert */}
				{formik.status && (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">{formik.status}</div>
					</div>
				)}
				{/* end: Alert */}

				{/* begin: Fullname */}
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.FULLNAME')}
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"name"
						)}`}
						name="name"
						{...formik.getFieldProps("name")}
					/>
					{formik.touched.name && formik.errors.name ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.name}</div>
						</div>
					) : null}
				</div>
				{/* end: Fullname */}

				{/* begin: phone */}
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.PHONE')}
						type="tel"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"phone"
						)}`}
						name="phone"
						{...formik.getFieldProps("phone")}
					/>
					{formik.touched.phone && formik.errors.phone ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.phone}</div>
						</div>
					) : null}
				</div>
				{/* end: phone */}

				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.EMAIL_OPTINAL')}
						type="email"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"email"
						)}`}
						name="email"
						{...formik.getFieldProps("email")}
					/>
					{formik.touched.email && formik.errors.email ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.email}</div>
						</div>
					) : null}
				</div>

				{/* begin: Username */}
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.USERNAME')}
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"username"
						)}`}
						name="username"
						{...formik.getFieldProps("username")}
					/>
					{formik.touched.username && formik.errors.username ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.username}</div>
						</div>
					) : null}
				</div>
				{/* end: Username */}

				{/* begin: Password */}
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.PASSWORD')}
						type="password"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"password"
						)}`}
						name="password"
						{...formik.getFieldProps("password")}
					/>
					{formik.touched.password && formik.errors.password ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.password}</div>
						</div>
					) : null}
				</div>
				{/* end: Password */}

				{/* begin: Confirm Password */}
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.CONFIRM_PASSWORD')}
						type="password"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"changepassword"
						)}`}
						name="changepassword"
						{...formik.getFieldProps("changepassword")}
					/>
					{formik.touched.changepassword && formik.errors.changepassword ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">
								{formik.errors.changepassword}
							</div>
						</div>
					) : null}
				</div>
				{/* end: Confirm Password */}

				{/* begin: Terms and Conditions */}
				<div className="form-group">
					<label className="checkbox">
						<input
							type="checkbox"
							name="acceptTerms"
							className="m-1"
							{...formik.getFieldProps("acceptTerms")}
						/>
						<Link
							to="/terms"
							target="_blank"
							className="mr-1"
							rel="noopener noreferrer"
						>
							{t('Rule')}
						</Link>
						<span/>
					</label>
					{formik.touched.acceptTerms && formik.errors.acceptTerms ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.acceptTerms}</div>
						</div>
					) : null}
				</div>
				{/* end: Terms and Conditions */}
				<div className="form-group d-flex flex-wrap flex-center">
					<button
						type="submit"
						disabled={
							formik.isSubmitting ||
							!formik.isValid ||
							!formik.values.acceptTerms
						}
						className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
					>
						<span>{t('AUTH.REGISTER.TITLE')}</span>
						{loading && <span className="ml-3 spinner spinner-white"></span>}
					</button>

					<Link to="/auth/login">
						<button
							type="button"
							className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
						>
							{t('Login')}
						</button>
					</Link>
				</div>
			</form>
		</div>
	);
}

export default connect(null, auth.actions)(Registration);
